// extracted by mini-css-extract-plugin
export var filterIncDec = "_br-0";
export var leftBorder = "_br-1";
export var rightBorder = "_br-2";
export var stringInput = "_br-3";